import { render, staticRenderFns } from "./NorticIconButton.vue?vue&type=template&id=2e72f8e0&scoped=true&"
import script from "./NorticIconButton.vue?vue&type=script&lang=js&"
export * from "./NorticIconButton.vue?vue&type=script&lang=js&"
import style0 from "./NorticIconButton.vue?vue&type=style&index=0&id=2e72f8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72f8e0",
  null
  
)

export default component.exports